import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import DataReactTable from './DataReactTable';
import ReactTableActionsFormula from './ReactTableActionsFormula'
import ReactTableActionsDiagnostic from './ReactTableActionsDiagnostic';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ReactTableActionsMedics from './ReacTableActionsMedics';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ModalTheme from '../../../../../shared/components/Modal';
import { faVial, faStethoscope, faNotesMedical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from '@material-ui/core/Tooltip';
import ProceduresModal from './ProceduresModal';
import LabsModal from './LabsModal';
import ConsulationModal from './ConsulationModal';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const Header = ({ column }) => (
  <span className="react-table__column-header">
    <span>
      {column}
    </span>
  </span>
);

class MedicalOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      observation: "",
      formulas: [],
      medicationsObservations: "",
      dataDiagnostic: [],
      addedDiagnostics: [],
      observations: [],
      loadAddedDiagnostics: false,
      openModal: false,
      load: false,
      countDiagnostic: 0,
      openMedicaments: false,
      loadMedicaments: false,
      dataMedicaments: [],
      medicament: [],
      total: 0,
      dosis: 0,
      frequence: '',
      frequenceVal: 0,
      duration: 0,
      modalOpen: false,
      odalProcedures: false,
      proceduresList: [],
      modalConsult: false,
      consultList: [],
      modalLabs: false,
      labList: [],
    };
  }
  //
  componentDidMount() {
    //console.log(this.props);
    //this.loadDiagnostic();
    /*this.setState({ load: true }, ()=>{
      this.props.loadMedicalOrders().then((load) => {
        this.setState({ load: load },()=>{
            console.log("cargar terminada !!");
        });
      }).catch((error)=>{
        console.log(error)
      });
    }) */   
    this.loadCups();
  }

  loadCups = () => {

    let proced = [], consul = [], labs = [];

    fetch(process.env.REACT_APP_PUBLIC_URL + 'servicio-acceso-rapido/listar', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {

        for (let obj of data) {
          obj.tipo === 1 ? labs.push(obj) :
            obj.tipo === 2 ? consul.push(obj) :
              proced.push(obj)
        }
        //console.log(data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    console.log(proced);
    this.setState({ proceduresList: proced, consultList: consul, labList: labs });
  }

  handlerModalProcedure = () => {
    this.setState({ modalProcedures: !this.state.modalProcedures });
  }

  handlerModalConsult = () => {
    this.setState({ modalConsult: !this.state.modalConsult });
  }

  handlerModalLabs = () => {
    this.setState({ modalLabs: !this.state.modalLabs });
  }


  handlerObservation = (observation) => {
    this.setState({ observation: observation });
  };

  handlerFormulasManager = (formula) => {
    var formulas = this.state.formulas;
    formulas.push(formula);
    this.setState({ formulas: formulas });
  }

  handlerMedicationsObservations = (medicationsObservations) => {
    this.setState({ medicationsObservations: medicationsObservations });
  };

  handlerDosis = (dosis) => {
    this.setState({ dosis: dosis });

  }

  handlerFrequence = (freq) => {
    this.setState({ frequence: freq });

    switch (freq) {
      case "Dos veces al día":
        this.setState({ frequenceVal: 2 });
        break;
      case "Tres veces al día":
        this.setState({ frequenceVal: 3 });
        break;
      case "Cuatro veces al día":
        this.setState({ frequenceVal: 4 });
        break;
      default:
        this.setState({ frequenceVal: 1 });
        break;
    }

  };

  
  addMoreDiagnostics = (diagnostic) => {

    //this.props.selectDiagnostic(diagnostic);
    var diagnosticNew = diagnostic;
    this.setState({ loadAddedDiagnostics: true, }, () => {

      var addedDiagnostics = this.state.addedDiagnostics;
      console.log(this.state.addedDiagnostics);
      if (!this.props.MedicalOrders.addedDiagnostics.includes(diagnosticNew)) {
        addedDiagnostics.push(diagnosticNew);
        this.props.MedicalOrders.addedDiagnostics.push(diagnosticNew);
      } else {
        alert("Ya se incluyo este diagnostico");
      }
      this.setState({ addedDiagnostics: addedDiagnostics, observations: [...this.state.observations, ""], loadAddedDiagnostics: false, countDiagnostic: this.state.countDiagnostic + 1 }, () => {
        //this.props.addDiagnostic(diagnosticNew);        
      });
    })

  }


  handlerDuration = (dur) => {
    this.setState({ duration: dur });

  }

  createFormula = () => {

    console.log(this.state.medicament.length);

    if (this.state.medicament.length === 0 || this.state.dosis === 0 || this.state.duration === 0 || this.state.frequence === "") {
      ///alert("Ingresa todos los datos de la formula"); 
      this.setState({ modalOpen: true });
    } else {

      let valor = (this.state.dosis * this.state.frequenceVal) * this.state.duration;

      let formula = {
        activePrinciple: this.state.medicament.principioactivo,
        concentration: this.state.medicament.cantidad + this.state.medicament.unidadmedida,
        pharmaceuticalForm: this.state.medicament.formafarmaceutica,
        route: this.state.medicament.viaadministracion,
        dose: this.state.dosis,
        frequency: this.state.frequence,
        duration: this.state.duration,
        units: valor
      };

      this.props.handlerFormulasNew(formula, this.props.reset);
      this.setState({ dosis: 0, duration: 0, medicament: [] });

    }
  }

  handlerTotalUnities = () => {

    let valor = (this.state.dosis * this.state.frequenceVal) * this.state.duration;
    console.log(valor);
    this.setState({ total: valor });

  }

  

  render() {
    const dataMedicalOrders = {
      tableHeaderData: [{
        Header: 'Codigo',
        accessor: 'codigo',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'Nombre',
        accessor: 'nombre',
      },
      ],
      tableRowsData: this.state.addedDiagnostics
    };

    const dataFormula = {
      tableHeaderData: [
        {
          Header: 'PRINCIPIO ACTIVO',
          accessor: 'activePrinciple',
          disableGlobalFilter: true,
          width: 65,
        },
        {
          Header: 'CONCENTRACIÓN',
          accessor: 'concentration',
        },
        {
          Header: 'FORMA FARMACEUTICA',
          accessor: 'pharmaceuticalForm',
        },
        {
          Header: 'VIA DE ADMINISTRACIÓN',
          accessor: 'route',
        },
        {
          Header: 'DOSIS',
          accessor: 'dose',
        },
        {
          Header: 'FRECUENCIA',
          accessor: 'frequency',
        },
        {
          Header: 'DURACIÓN',
          accessor: 'duration',
        },
        {
          Header: 'UNIDADES',
          accessor: 'units',
        }
      ],
      tableRowsData: this.props.MedicalOrders.formulas
    };

    const reactTableMedicaments = {
      tableHeaderData: [{
        Header: 'Principio activo',
        accessor: 'principioactivo',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'Producto',
        accessor: 'producto',
      },
      {
        Header: 'Forma Farmacéutica',
        accessor: 'formafarmaceutica',
      },
      {
        Header: 'Codigo',
        accessor: 'atc',
      },
      ],
      tableRowsData: this.state.dataMedicaments
    };

    const reactTableFoundDiagnostics = {
      tableHeaderData: [{
        Header: 'Codigo',
        accessor: 'cupscod',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'Nombre',
        accessor: 'cupsnom',
      },
      ],
      tableRowsData: this.state.dataDiagnostic
    }



    return (<Col>
      {!this.props.MedicalOrders.load ?
        <>
          <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
            <div className="card__title">
              <h5 className="bold-text">Procedimiento y Servicios</h5>
            </div>
            <div style={{ marginBottom: 10 }}>
                <Tooltip title="Procedimeientos Medicos">
                  <Button
                    color="primary"
                    style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                    onClick={() => {
                      this.setState({ modalProcedures: true });
                    }}
                  >
                    <FontAwesomeIcon icon={faNotesMedical} style={{ color: 'gray' }} />
                  </Button>
                </Tooltip>
                <Tooltip title="Examenes de Laboratorio">
                  <Button
                    color="primary"
                    style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                    onClick={() => {
                      this.setState({ modalLabs: true });
                    }}
                  >
                    <FontAwesomeIcon icon={faVial} style={{ color: 'gray' }} />
                  </Button>
                </Tooltip>
                <Tooltip title="Consultas Especializadas">
                  <Button
                    color="primary"
                    style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                    onClick={() => {
                      this.setState({ modalConsult: true });
                    }}
                  >
                    <FontAwesomeIcon icon={faStethoscope} style={{ color: 'gray' }} />
                  </Button>
                </Tooltip>
              </div>
              {this.state.modalProcedures ? <ProceduresModal data={this.state.proceduresList} openModal={this.state.modalProcedures} setOpenModal={this.handlerModalProcedure} addDiagnostic={this.addMoreDiagnostics} /> : null}
              {this.state.modalConsult ? <ConsulationModal data={this.state.consultList} openModal={this.state.modalConsult} setOpenModal={this.handlerModalConsult} addDiagnostic={this.addMoreDiagnostics} /> : null}
              {this.state.modalLabs ? <LabsModal data={this.state.labList} openModal={this.state.modalLabs} setOpenModal={this.handlerModalLabs} addDiagnostic={this.addMoreDiagnostics} /> : null}
            <div>
              <div className="form__form-group" style={{ width: 500, minWidth: 250 }}>
                <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} >Buscar </span>
                <Button
                  color="primary"
                  style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                  onClick={() => {

                    this.setState({ openModal: !this.state.openModal });
                  }}
                >
                  <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                </Button>
              </div>
            </div>
          </div>
          <div>
            <table className="table table--bordered" >
              <thead className="thead th">
                <tr className="react-table thead tr">
                  <th>
                    <Header column="CUPS" />
                  </th>
                  <th>
                    <Header column="DESCRIPCIÓM" />
                  </th>
                  <th>
                    <Header column="OBSERVACIÓN" />
                  </th>
                  <th>
                    <Header column="ACCIÓN" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.MedicalOrders.addedDiagnostics.map((diagnostic, index) => {
                  return <tr key={index}>
                    <td>{diagnostic.cupscod}</td>
                    <td>{diagnostic.cupsnom}</td>
                    <td>
                      <div className="form">
                        <div className="form__form-group">
                          <div className="form__form-group-field">
                            <input
                              name={`observation-${index}`}
                              type="text"
                              value={this.state.observations[index]}
                              onChange={(e) => {
                                var observations = this.state.observations;
                                observations[index] = e.target.value;
                                this.setState({ observations: observations });
                                this.props.addObservation(index, e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style={{ marginLeft: 10 }}>
                      <DeleteForeverIcon onClick={() => {
                        var data = this.state.addedDiagnostics;
                        data = data.filter((value, indexDiag) => {
                          return indexDiag !== index;
                        });
                        var observations = this.state.observations;
                        observations = observations.filter((value, indexDiag) => {
                          return indexDiag !== index;
                        });
                        console.log(data);
                        console.log(index);
                        this.setState({ addedDiagnostics: data, observations: observations, countDiagnostic: this.state.countDiagnostic - 1 }, () => {
                          this.props.removeDiagnostic(index);
                        })
                      }}
                      />
                    </td>
                  </tr>
                })}
              </tbody>
            </table>

          </div>
          <div className="form">
            <div className="form__form-group" style={{ marginTop: 10 }}>
              <span className="form__form-group-label">Observaciones exámenes</span>
              <div className="form__form-group-field">
                <Field
                  name="textarea-observations-exams"
                  component="textarea"
                  type="text"
                  value={this.state.observation}
                  onChange={(e) => {
                    this.handlerObservation(e.value)
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <div>
              <div className="form__form-group" style={{ width: 500, minWidth: 250 }}>
                <div className="card__title">
                  <h5 className="bold-text">Medicamentos</h5>
                </div>
                <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} >Buscar Medicamentos</span>
                <Button
                  color="primary"
                  style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                  onClick={() => {

                    this.setState({ openMedicaments: !this.state.openMedicaments });
                  }}
                >
                  <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                </Button>
              </div>
              <table className="table table--bordered" >
                <thead>
                  <tr>
                    <td >Principio Activo - Denominación Común Internacional </td>
                    <td >Concentración </td>
                    <td >Forma Farmacéutica </td>
                    <td >Vía de Administración </td>
                    <td >Dosis </td>
                    <td >Frecuencia </td>
                    <td >Duración (Días) </td>
                    <td > </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td ><TextField
                      type="text"
                      className="material-form__field"
                      disabled
                      style={{ width: 350 }}
                      value={typeof this.state.medicament?.principioactivo !== 'undefined' ? this.state.medicament?.principioactivo : ""}
                    /> </td>
                    <td ><TextField
                      type="text"
                      className="material-form__field"
                      disabled
                      style={{ width: 100 }}
                      value={typeof this.state.medicament?.cantidad !== 'undefined' ? this.state.medicament?.cantidad + this.state.medicament?.unidadmedida : ""}
                    />  </td>
                    <td ><TextField
                      type="text"
                      className="material-form__field"
                      disabled
                      style={{ width: 200 }}
                      value={typeof this.state.medicament?.formafarmaceutica !== 'undefined' ? this.state.medicament?.formafarmaceutica : ""}
                    />  </td>
                    <td ><TextField
                      type="text"
                      className="material-form__field"
                      disabled
                      style={{ width: 150 }}
                      value={typeof this.state.medicament?.viaadministracion !== 'undefined' ? this.state.medicament?.viaadministracion : ""}
                    /> </td>
                    <td ><TextField
                      required
                      type="number"
                      className="material-form__field"
                      style={{ width: 80 }}
                      value={this.state.dosis}
                      onChange={(event) => {
                        this.handlerDosis(event.target.value);
                      }}
                    />  </td>
                    <td ><TextField
                      className="material-form__field"
                      style={{ width: 180, }}
                      select
                      onChange={(event) => {
                        this.handlerFrequence(event.target.value);
                      }}
                    >

                      <MenuItem className="material-form__option" key={0} value={'Una vez al día'}>Una vez al día</MenuItem>
                      <MenuItem className="material-form__option" key={1} value={'Dos veces al día'}>Dos veces al día</MenuItem>
                      <MenuItem className="material-form__option" key={2} value={'Tres veces al día'}>Tres veces al día</MenuItem>
                      <MenuItem className="material-form__option" key={3} value={'Cuatro veces al día'}>Cuatro veces al día</MenuItem>
                      <MenuItem className="material-form__option" key={4} value={'Dos veces a la semana'}>Dos veces a la semana</MenuItem>
                      <MenuItem className="material-form__option" key={5} value={'Cada mes'}>Cada mes</MenuItem>
                      <MenuItem className="material-form__option" key={6} value={'Cada dos meses'}>Cada dos meses</MenuItem>
                      <MenuItem className="material-form__option" key={7} value={'Cada seis meses'}>Cada seis meses</MenuItem>
                      <MenuItem className="material-form__option" key={8} value={'Dosis unica'}>Dosis unica</MenuItem>
                    </TextField> </td>
                    <td ><TextField
                      required
                      type="number"
                      className="material-form__field"
                      style={{ width: 100 }}
                      value={this.state.duration}
                      onChange={(event) => {
                        this.handlerDuration(event.target.value);
                      }}
                    />  </td>
                    <td ><Button color="primary" onClick={() => {
                      this.createFormula();

                    }}>
                      <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                    </Button></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <DataReactTable
                title=""
                reactTableData={dataFormula}
                config={{
                  withPagination: true,
                  withSearchEngine: false,
                  isSortable: false,
                  isEditable: false,
                  watchCustomMenu: false
                }}
                ReactTableActions={ReactTableActionsFormula}
                Callback={() => {
                  var data = this.state.formulas;
                  data.pop();
                  this.setState({ formulas: data }, () => {
                    this.props.removeFormula();
                  });
                }}
              />
            </div>
            <div className="form">
              <div className="form__form-group" style={{ marginTop: 10 }}>
                <span className="form__form-group-label">Observaciones Medicamentos</span>
                <div className="form__form-group-field">
                  <Field
                    name="textarea-medications-observations"
                    component="textarea"
                    type="text"
                    value={this.state.medicationsObservations}
                    onChange={(e) => {
                      this.handlerMedicationsObservations(e.value)
                    }}
                  />

                </div>
              </div>
            </div>
          </div>
          {this.state.openModal ?
            <Modal
              open={this.state.openModal}
              onClose={() => {
                this.setState({ openModal: false });
              }}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ zIndex: 1000 }}
            >
              <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                <div>
                  <h5 className="bold-text">Procedimiento</h5>
                </div>
                <div className="form">
                  <div style={{ display: 'flex', width: '100%' }}>
                    <div className="form__form-group" style={{ marginRight: 10 }}>
                      <span className="form__form-group-label">CUPS</span>
                      <div className="form__form-group-field">
                        <Field
                          name="search-cups"
                          component="input"
                          type="text"
                          placeholder="Codigo"
                          //value={this.props.MedicalOrders.cups.cupsnom}
                          onChange={(e) => {
                            //this.props.handlerCUPS(e.target.value);
                            console.log(e.target.value);
                            this.setState({ load: true }, () => {
                              this.props.searchDiagnostic("", e.target.value).then((dataDiagnostic) => {
                                console.log(dataDiagnostic);
                                this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                              });
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">Nombre</span>
                      <div className="form__form-group-field">
                        <input
                          name="search-diagnostic"
                          type="text"
                          placeholder="descripcion"
                          //value={this.props.Diagnostic.name}
                          onChange={(e) => {
                            //this.props.handlerDiagnosticName(e.target.value);
                            var diagnostic = e.target.value;
                            this.setState({ load: true }, () => {
                              console.log(diagnostic)
                              this.props.searchDiagnostic(diagnostic, "").then((dataDiagnostic) => {
                                console.log(dataDiagnostic);
                                this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                              });
                            });
                          }}
                        >
                        </input>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                  {!this.state.load ?
                    <DataReactTable
                      title=""
                      reactTableData={reactTableFoundDiagnostics}
                      config={{
                        withPagination: true,
                        withSearchEngine: false,
                        isSortable: false,
                        watchCustomMenu: false
                      }}
                      ReactTableActions={ReactTableActionsDiagnostic}
                      Callback={(diagnostic) => {
                        this.props.selectDiagnostic(diagnostic);
                        var diagnosticNew = diagnostic;
                        this.setState({ loadAddedDiagnostics: true }, () => {

                          var addedDiagnostics = this.state.addedDiagnostics;
                          if (!addedDiagnostics.includes(diagnosticNew)) {
                            addedDiagnostics.push(diagnosticNew);
                          } else {
                            alert("Ya se incluyo este diagnostico");
                          }
                          this.setState({ addedDiagnostics: addedDiagnostics, observations: [...this.state.observations, ""], loadAddedDiagnostics: false, countDiagnostic: this.state.countDiagnostic + 1 }, () => {
                            this.props.addDiagnostic(diagnosticNew);
                          });
                        })
                      }}
                    /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                      <div class="load__icon-wrap">
                        <svg class="load__icon">
                          <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                        </svg>
                      </div>
                    </div>}
                  {!this.state.load && this.state.dataDiagnostic.length == 0 ?
                    <div style={{ margin: 'auto', width: 270, height: 420 }}>
                      No hay elementos que mostrar
                    </div>
                    : null}
                </div>
              </div>
            </Modal> : null}
          <Modal
            open={this.state.openMedicaments}
            onClose={() => {
              this.setState({ openMedicaments: false });
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
          >
            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
              <div>
                <h5 className="bold-text">Medicamentos</h5>
              </div>
              <div className="form">
                <div style={{ display: 'flex', width: '100%' }}>
                  <div className="form__form-group" style={{ marginRight: 10 }}>
                    <span className="form__form-group-label">Principio Activo</span>
                    <div className="form__form-group-field">
                      <Field
                        name="search-cups"
                        component="input"
                        type="text"
                        placeholder="nombre"
                        //value={this.props.MedicalOrders.cups.cupsnom}
                        onChange={(e) => {
                          //this.props.handlerCUPS(e.target.value);
                          console.log(e.target.value);
                          this.setState({ loadMedicaments: true }, () => {
                            this.props.searchMedicaments(e.target.value).then((dataMedicaments) => {
                              console.log(dataMedicaments)
                              this.setState({ dataMedicaments: dataMedicaments, loadMedicaments: false })
                            })
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                {!this.state.loadMedicaments ?
                  <DataReactTable
                    title=""
                    reactTableData={reactTableMedicaments}
                    config={{
                      withPagination: true,
                      withSearchEngine: false,
                      isSortable: false,
                      watchCustomMenu: false
                    }}
                    ReactTableActions={ReactTableActionsMedics}
                    Callback={(medicament) => {
                      //console.log(medicament);
                      this.setState({ medicament: medicament, openMedicaments: false });
                    }}
                  /> : <div style={{ margin: 'auto', width: 280, height: 480 }}>
                    <div class="load__icon-wrap">
                      <svg class="load__icon">
                        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </div>}
                {!this.state.openMedicaments && this.state.dataMedicaments.length == 0 ?
                  <div style={{ margin: 'auto', width: 280, height: 480 }}>
                    No hay elementos que mostrar
                  </div>
                  : null}
              </div>
            </div>
          </Modal>
        </>
        : null}
      <ModalTheme
        color={'danger'}
        title={"Error"}
        message={"Ingresa todos los datos de la formula"}
        modal={this.state.modalOpen}
        toggle={() => { this.setState({ modalOpen: !this.state.modalOpen }); }}
        onOk={() => { this.setState({ modalOpen: !this.state.modalOpen }); }} />

    </Col>);
  }
}

export default reduxForm({
  form: `medical-orders-form`, // a unique identifier for this form
})(withTranslation('common')(MedicalOrders));